<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_4"></a>Copyright © 2000 by Fay Weldon</p>
<p class="copyright">All rights reserved. No part of this book may be reproduced in any form or by<br/>any electronic or mechanical means, including information storage and<br/>retrieval systems, without permission in writing from the publisher, except by<br/>a reviewer, who may quote brief passages in a review. Any members of<br/>educational institutions wishing to photocopy part or all of the work for<br/>classroom use, or publishers who would like to obtain permission to include<br/>the work in an anthology, should send their inquiries to Grove/Atlantic, Inc.,<br/>841 Broadway, New York, NY 10003.</p>
<p class="copyrighta">First published in 2000 by BVLGARI Italy S.p.A., Rome, Italy</p>
<p class="copyrightb">First published in Great Britain in 2001 by HarperCollins Publishers Ltd.,<br/>London, England</p>
<p class="copyright"><em>Printed in the United States of America</em></p>
<p class="copyright"><span class="small">FIRST GROVE PRESS EDITION</span></p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright1">Weldon, Fay.<br/>     The Bulgari connection : a novel / by Fay Weldon.<br/>            p. cm.<br/>     eBook ISBN-13: 978-1-5558-4801-9<br/>     1. Rich people—Fiction. 2. Revenge—Fiction. I. Title.</p>
<p class="copyright1">     PR6073.E374 B85 2001<br/>      823′.914—dc21             2001033294</p>
<p class="copyright">Design by FG confalonieri</p>
<p class="copyright">Grove Press<br/>841 Broadway<br/>New York, NY 10003</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?85c157e6